/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/subjects/', params);
}

function get(id, params) {
  return api.get(`/subjects/${id}`, params);
}

function teachers(id, params) {
  return api.get(`/subjects/${id}/teachers`, params);
}

function create(params) {
  return api.post('/subjects', params);
}

function update(id, params) {
  return api.put(`/subjects/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/subjects/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

function exportData(params) {
  return api.get('/subjects-export', params);
}

export const subjectsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
  teachers,
  exportData,
};
